// 原片管理每个key的含义
export const baseMaterialFormTextObj = {
  plankWidth: '板材宽度(mm)',
  plankHeight: '材质长度(mm)',
  plankEdgeOff: '修边尺寸(mm)',
}

// 原片管理-设置弹窗
export const baseMaterialSettingFormTextObj = {
  autoAddSpecialPlate: '排版时如果板件超尺，弹出自动添加特殊大板弹窗',
  isAutoSelected: '尺寸过大时，自动选用更大尺寸规格大板进行排版',
  onlyLayoutTooBig: '超尺大板只排超尺小板',
  default_oversize_plank_value: {
    checked: '设置超尺特殊大板的默认添加尺寸',
    height: '大板长度(mm)',
    width: '大板宽度(mm)',
  },
}

export const baseMaterialSettingFormValueObj = {
  autoAddSpecialPlate: {
    true: '开启',
    false: '关闭',
  },
  isAutoSelected: {
    true: '开启',
    false: '关闭',
  },
  onlyLayoutTooBig: {
    true: '开启',
    false: '关闭',
  },
  default_oversize_plank_value: {
    checked: {
      true: '开启',
      false: '关闭',
    },
  },
}
